import posthog from "posthog-js";
import { isAnnouncementFlag } from "../announcement/utils";
import _partition from "lodash/partition";
import { useEffect, useState } from "react";
import { useFeatureStore } from "../feature/useFeatureStore";
import { useAnnouncementStore } from "../announcement/useAnnouncementStore";
import { useSurveyStore } from "../survey/useSurveyStore";
function extractFlagPayloads(flags) {
    return flags.reduce((acc, flag) => {
        const payload = posthog.getFeatureFlagPayload(flag);
        if (payload)
            acc[flag] = payload;
        return acc;
    }, {});
}
export const useInitPostHogStore = () => {
    const [hasLoaded, setHasLoaded] = useState(false);
    const { setFeature } = useFeatureStore();
    const { setAnnouncement } = useAnnouncementStore();
    const { setSurvey } = useSurveyStore();
    useEffect(() => {
        if (hasLoaded)
            return;
        posthog.onFeatureFlags((flags) => {
            const [announcementFlags, featureFlags] = _partition(flags, isAnnouncementFlag);
            setFeature({
                isLoaded: true,
                flags: new Set(featureFlags),
                payloads: extractFlagPayloads(featureFlags),
            });
            setAnnouncement({
                isLoaded: true,
                flags: new Set(announcementFlags),
                payloads: extractFlagPayloads(announcementFlags),
            });
            setHasLoaded(true);
        });
        posthog.getActiveMatchingSurveys((surveys) => {
            const ids = surveys.map((_survey) => _survey.id);
            setSurvey({
                isLoaded: true,
                flags: new Set(ids),
                payloads: surveys.reduce((acc, _survey) => {
                    acc[_survey.id] = _survey;
                    return acc;
                }, {}),
            });
        });
    }, [posthog, hasLoaded, setSurvey, setFeature, setAnnouncement]);
};
